// src/redux/reducers/vendorRegistrationReducer.js

import {
  SET_VENDOR_DRAFT,
  CLEAR_VENDOR_DRAFT,
} from '../actions/vendorRegistrationActions';

const initialState = {
  draft: {
    vendor_name:       '',
    mobile_no:         '',
    email_id:          '',
    vendor_shop_name:  '',
    gst_number:        '',
    address:           '',
    pin_code:          '',
  },
};

export const setVendorDraft = (payload) => ({
  type: SET_VENDOR_DRAFT,
  payload,
});

export const clearVendorDraft = () => ({
  type: CLEAR_VENDOR_DRAFT,
});


export default function vendorRegistrationReducer(state = initialState, action) {
  switch (action.type) {
    case SET_VENDOR_DRAFT:
      return {
        ...state,
        draft: {
          ...state.draft,
          ...action.payload,
        },
      };

    case CLEAR_VENDOR_DRAFT:
      return {
        ...state,
        draft: { ...initialState.draft },
      };

    default:
      return state;
  }
}
